// 全局router
let glbalRouter = null;

module.exports = {
    getBackendApiBase() {
        if (process.env.NODE_ENV == "dev") {
            return process.env.VUE_APP_BACKEND_API_BASE
        } else {
            return window.location.origin;
        }
    },

    /**
     * 保存全局router
     */
    saveGlobalRouter(router) {
        glbalRouter = router;
    },

    /**
     * 跳转到登录页面
     */
    gotoLoginPage() {
        glbalRouter.push({ name: "login" });
    },

    /**
     * 往localStorage里保存数据
     * @param {*} key 
     * @param {*} value 
     * @param {*} expireAfterSeconds 多久以后过期，单位是秒。小于或等于0则表示永不过期。
     */
    storeToLocalStorage(key, value, expireAfterSeconds) {
        // 过期时间，unixtime，单位是秒
        let expireAfter = 0;
        if (expireAfterSeconds > 0) {
            expireAfter = Math.round((new Date()).getTime() / 1000) + expireAfterSeconds;
        }

        let v = {
            value: value,
            expireAfter: expireAfter,
        };

        localStorage.setItem(key, JSON.stringify(v));
    },

    /**
     * 从localStorage里读取数据
     * @param {*} key 
     * @returns 
     */
    getFromLocalStorage(key) {
        let vStr = localStorage.getItem(key);
        if (!vStr) {
            return "";
        }

        let v = JSON.parse(vStr);
        if (v.expireAfter > 0 && v.expireAfter <= Math.round((new Date()).getTime() / 1000)) {
            localStorage.removeItem(key);
            return ""
        }

        return v.value;
    },

    /**
     * 从localStorage里删除数据
     * @param {*} key 
     * @returns 
     */
    removeFromLocalStorage(key) {
        localStorage.removeItem(key);
    },

    /**
    * 取得当前登录用户的token
    */
    getLoginUserToken() {
        let loginUser = this.getFromLocalStorage("loginUser");
        if (loginUser) {
            return loginUser.token;
        } else {
            return "";
        }
    },
}